import { render, staticRenderFns } from "./Author.vue?vue&type=template&id=a36e5ebc&scoped=true&"
import script from "./Author.vue?vue&type=script&lang=js&"
export * from "./Author.vue?vue&type=script&lang=js&"
import style0 from "./Author.vue?vue&type=style&index=0&id=a36e5ebc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36e5ebc",
  null
  
)

export default component.exports